import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "@/components/LoginPage";
import ProfessorDashboard from "@/components/ProfessorDashboard";
import SecureConfirm from "@/components/SecureConfirm";
import TutorConsole from "@/components/TutorConsole";
import ErrorBoundary from "@/components/ErrorBoundary";
import { logout as logoutApi } from "@/lib/api";

const Home = () => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("stagelink-user");
    return saved ? JSON.parse(saved) : null;
  });

  const handleLogin = (nextUser) => {
    localStorage.setItem("stagelink-user", JSON.stringify(nextUser));
    setUser(nextUser);
  };
  const handleLogout = async () => {
    try {
      await logoutApi();
    } catch {
      // La session locale est supprimée même si le jeton est déjà expiré côté serveur.
    } finally {
      localStorage.removeItem("stagelink-user");
      setUser(null);
    }
  };

  if (!user) return <LoginPage onLogin={handleLogin} />;
  if (user.role === "tutor") return <TutorConsole user={user} onLogout={handleLogout} />;
  return <ProfessorDashboard user={user} onLogout={handleLogout} />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/confirm/:token" element={<SecureConfirm />} />
          </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
}

export default App;
